import { FC, ReactNode } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { TemplateSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'

export interface TemplateCardProps {
  sizes: string // L ML M S
  children?: ReactNode
  className?: string
  animate?: boolean
}

const Skeleton: FC<TemplateCardProps> = (props) => {
  return (
    <BlockBoundary>
      <TemplateSkeleton {...props} />
    </BlockBoundary>
  )
}

export default Skeleton
